export default __webpack_public_path__ + "static/media/Executive_Role.154b4225.svg";